import { alpha, styled } from '@mui/material/styles';
import type { AccentColor } from '../AccentCard';

/** Translucent fill of the accent's light shade, for inline notices. */
export const TintedBox = styled('div', {
  shouldForwardProp: prop => prop !== 'accent',
})<{ accent: AccentColor }>(({ theme, accent }) => ({
  backgroundColor: alpha(theme.palette[accent].light, 0.35),
}));
